import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Container, 
  Paper, 
  Chip,
  Divider,
  Grid
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EmailIcon from '@mui/icons-material/Email';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { isInApp } from '../utils/environment';
import TopBar from '../components/TopBar';
import { removeToken } from '../utils/auth';
import { showMessage } from '../utils';
import { handleCopyLink } from '../utils/share';

const PaymentSuccessScreen = () => {
  const location = useLocation();
  const { couponTemplateListItem } = location.state || {};
  const navigate = useNavigate();
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const handleUserMenuOpen = (event) => setUserMenuAnchor(event.currentTarget);
  const handleUserMenuClose = () => setUserMenuAnchor(null);

  return (
    <Box>
      <TopBar
        onShareClick={() => navigate('/campaigns/invitations/referral')}
        onCouponClick={() => navigate('/campaigns/invitations/tax-declaration')}
        onAvatarClick={handleUserMenuOpen}
        userMenuAnchor={userMenuAnchor}
        handleCopyLink={handleCopyLink}
        onUserMenuClose={handleUserMenuClose}
        navigate={navigate}
        onLogout={() => {
          removeToken();
          showMessage("Logoutsuccessfully", "success");
          setTimeout(() => {
            navigate("/login");
          }, 1500);
          handleUserMenuClose();
        }}
      />
      <Container 
        sx={{
          mt: { xs: '56px', md: '64px' },
          minHeight: '100vh',
          padding: 0, 
          bgcolor: '#f5f5f7',
          boxShadow: '0 4px 30px rgba(0,0,0,0.1)',
          position: 'relative',
          fontFamily: 'SF Pro Display, -apple-system, BlinkMacSystemFont, Roboto, sans-serif'
        }}
      >
        {
          !isInApp() && (
            <Box sx={{ 
              height: 56, 
              bgcolor: '#ffffff', 
              display: 'flex', 
              justifyContent: 'center',
              alignItems: 'center',
              borderBottom: '1px solid #f0f0f0'
            }}>
              <Typography sx={{ 
                fontWeight: 600, 
                fontSize: 17, 
                color: '#000000'
              }}>
                Payment Success
              </Typography>
            </Box>
          )
        }
        
        {/* 成功提示 */}
        <Box sx={{ 
          bgcolor: '#f5f5f7', 
          py: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          px: 3
        }}>
          <Box sx={{ 
            width: 64, 
            height: 64, 
            borderRadius: '50%', 
            bgcolor: '#007AFF',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mb: 2
          }}>
            <CheckIcon sx={{ color: 'white', fontSize: 32 }} />
          </Box>
          <Typography sx={{ 
            fontWeight: 600, 
            fontSize: 22, 
            mb: 1,
            color: '#000000'
          }}>
            Payment Successful!
          </Typography>
          <Typography sx={{ 
            color: '#6B7280', 
            textAlign: 'center', 
            fontSize: 15,
            fontWeight: 400,
            lineHeight: 1.4
          }}>
            Your coupon has been purchased and is ready to use.
          </Typography>
        </Box>
        
        {/* 优惠券详情 */}
        <Paper sx={{ 
          mx: 2, 
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
        }}>
          <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography sx={{ 
              fontWeight: 600, 
              fontSize: 17, 
              color: '#000000'
            }}>
              Premium Deal
            </Typography>
            <Chip 
              label="Best Value" 
              sx={{ 
                bgcolor: '#007AFF', 
                color: 'white',
                fontWeight: 600,
                fontSize: 11,
                height: 22,
                borderRadius: '4px'
              }} 
            />
          </Box>
          
          <Box sx={{ px: 2, pb: 2 }}>
            <Typography sx={{ 
              fontWeight: 700, 
              fontSize: 34,
              color: '#000000',
              lineHeight: 1.2
            }}>
              ${couponTemplateListItem?.facePrice}
            </Typography>
            <Typography sx={{ 
              color: '#6B7280', 
              letterSpacing: 0.5,
              fontSize: 14,
              fontWeight: 500
            }}>
              PREMIUM100
            </Typography>
          </Box>
          
          <Divider sx={{ backgroundColor: '#E5E7EB' }} />
          
          <Box sx={{ p: 2 }}>
            <Grid container spacing={1.5}>
              <Grid item xs={6}>
                <Typography sx={{ 
                  color: '#6B7280', 
                  fontSize: 14,
                  fontWeight: 400
                }}>
                  Valid Until
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={{ 
                  textAlign: 'right', 
                  fontWeight: 500, 
                  fontSize: 14,
                  color: '#000000'
                }}>
                  Jan 15, 2025
                </Typography>
              </Grid>
              
              <Grid item xs={6}>
                <Typography sx={{ 
                  color: '#6B7280', 
                  fontSize: 14,
                  fontWeight: 400
                }}>
                  Minimum Purchase
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={{ 
                  textAlign: 'right', 
                  fontWeight: 500, 
                  fontSize: 14,
                  color: '#000000'
                }}>
                  ${couponTemplateListItem?.facePrice}
                </Typography>
              </Grid>
              
              <Grid item xs={6}>
                <Typography sx={{ 
                  color: '#6B7280', 
                  fontSize: 14,
                  fontWeight: 400
                }}>
                  Usage Limit
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={{ 
                  textAlign: 'right', 
                  fontWeight: 500, 
                  fontSize: 14,
                  color: '#000000'
                }}>
                  One-time use
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Paper>
        
        {/* 功能按钮 */}
        <Box sx={{ px: 2, mt: 3, pb: 4 }}>
          <Button 
            variant="outlined"
            fullWidth
            startIcon={<ContentCopyIcon sx={{ fontSize: 20 }} />}
            sx={{ 
              py: 1.5,
              mb: 2,
              borderColor: '#E5E7EB',
              color: '#000000',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 500,
              fontSize: 15,
              bgcolor: 'white',
              height: 48,
              '&:hover': {
                borderColor: '#D1D5DB',
                bgcolor: 'rgba(255,255,255,0.95)'
              }
            }}
          >
            Copy Coupon Code
          </Button>
          
          {/* <Button 
            variant="outlined"
            fullWidth
            startIcon={<EmailIcon sx={{ fontSize: 20 }} />}
            sx={{ 
              py: 1.5,
              mb: 2,
              borderColor: '#E5E7EB',
              color: '#000000',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 500,
              fontSize: 15,
              bgcolor: 'white',
              height: 48,
              '&:hover': {
                borderColor: '#D1D5DB',
                bgcolor: 'rgba(255,255,255,0.95)'
              }
            }}
          >
            Email Receipt
          </Button> */}
          
          <Button 
            variant="contained"
            fullWidth
            onClick={() => navigate('/')}
            sx={{ 
              py: 1.5,
              bgcolor: '#000000',
              color: 'white',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 500,
              fontSize: 15,
              height: 48,
              boxShadow: 'none',
              '&:hover': {
                bgcolor: '#333333',
                boxShadow: 'none'
              }
            }}
          >
            Back to Home
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default PaymentSuccessScreen;
